export default __webpack_public_path__ + "static/media/718.f863b3a3.gif";